import { render } from "./GreyCard.vue?vue&type=template&id=1d76081a&scoped=true"
const script = {}

import "./GreyCard.vue?vue&type=style&index=0&id=1d76081a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d76081a"]])

export default __exports__